export default __webpack_public_path__ + "static/media/forum.9c099989.svg";